const Step3FinalReview = ({ form, onBack, onSubmit }) => {
  return (
    <div className="space-y-10">

      {/* Title */}
      <h2 className="text-lg font-semibold text-white">
        Final Review
      </h2>

      {/* Placeholder Card */}
      <div className="bg-slate-900/60 border border-white/10 rounded-xl p-8 text-center">

        <p className="text-slate-300 text-sm">
          Contract section will be implemented later.
        </p>

      </div>

      {/* Buttons */}
      <div className="flex justify-center gap-4 pt-6">

        <button
          onClick={onBack}
          className="px-6 py-2 rounded-lg border border-white/10 text-slate-300 hover:bg-slate-800 transition"
        >
          Back
        </button>

        <button
          onClick={onSubmit}
          className="px-8 py-2 rounded-lg bg-pink-600 hover:bg-pink-700 text-white font-medium transition"
        >
          Confirm Booking
        </button>

      </div>

    </div>
  );
};

export default Step3FinalReview;